<div class="modal-header">
    <h4 class="modal-title">Fødselsdage for alle kunder og kollegaer</h4>
    <button (click)="activeModal.dismiss('Cross click')" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
</div>

<div class="modal-body">
    <ng-container *ngIf="birthDays?.clientsWithBirthday?.length > 0">
        <i>Kunder:</i>
        <div class="table-responsive">
            <table class="clickableTable table table-hover table-striped table-sm">
                <tbody>
                    <tr *ngFor="let client of birthDays.clientsWithBirthday"
                    (click)="gotoClient(client.kid)">
                        <td>{{client?.navn1}}</td>
                        <td class="text-end">{{client?.birthdayThisYear | date:'dd. MMM'}}</td>
                        <td class="text-end">{{client?.age}} år</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </ng-container>
    <ng-container *ngIf="birthDays?.spousesWithBirthday?.length > 0">
        <i>Ægtefæller:</i>
        <div class="table-responsive">
            <table class="clickableTable table-hover table table-striped table-sm">
                <tbody>
                    <tr *ngFor="let client of birthDays.spousesWithBirthday"
                    (click)="gotoClient(client.kid)">
                        <td>{{client?.navn1}}</td>
                        <td class="text-end">{{client?.birthdayThisYear | date:'dd. MMM'}}</td>
                        <td class="text-end">{{client?.age}} år</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </ng-container>
    <ng-container *ngIf="birthDays?.employeesWithBirthday?.length > 0">
        <i>Kollegaer:</i>
        <div class="table-responsive">
            <table class="table table-striped table-sm">
                <tbody>
                    <tr *ngFor="let user of birthDays.employeesWithBirthday">
                        <td>{{user?.navn}}</td>
                        <td class="text-end">{{user?.birthdayThisYear | date:'dd. MMM'}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </ng-container>
</div>
